export default __webpack_public_path__ + "static/media/element_46.27cd2e3c.webp";